import { Link } from "react-router-dom";
import type { Work } from "@/mocks/works";

export default function WorkCard({ work }: { work: Work }) {
  return (
    <Link
      to={`/works#${work.slug}`}
      className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-accent-300 hover:shadow-[0_10px_30px_-12px_rgba(222,144,34,0.35)]"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={work.cover}
          alt={`韩国妖精漫画《${work.title}》封面`}
          title={`《${work.title}》`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-medium text-background-50 ${
            work.status === "已完结" ? "bg-secondary-500" : "bg-primary-500"
          }`}
        >
          {work.status}
        </span>
        <div className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-semibold text-foreground-900 backdrop-blur">
          <i className="ri-star-fill text-accent-500" aria-hidden="true"></i>
          {work.rating.toFixed(1)}
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950">《{work.title}》</h3>
        <p className="text-xs text-foreground-500">{work.chapters} · {work.genre.join(" / ")}</p>
        <div className="flex flex-wrap gap-1.5">
          {work.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="rounded-full bg-background-100 px-2 py-0.5 text-xs text-foreground-600">
              {tag}
            </span>
          ))}
        </div>
        <p className="mt-1 line-clamp-2 text-sm text-foreground-600">{work.intro}</p>
      </div>
    </Link>
  );
}